<template>
  <ul
    ref="scrollContainer"
    class="scrollbar-none -mx-10 flex min-h-[3.1875rem] items-center overflow-x-auto px-10 md:space-x-1"
  >
    <li>
      <NuxtLink
        :to="{
          query: {
            [queryScope]: JSON.stringify({
              level: 0,
            }),
          },
        }"
        class="my-2 flex items-center px-4 py-2"
        :class="{
          'pointer-events-none rounded bg-blue-50': !breadcrumbs.length,
        }"
      >
        <FolderIcon class="mr-2 w-5 text-blue-800 md:mr-3" />
        <span class="truncate text-sm font-medium sm:text-base">
          <slot />
        </span>
      </NuxtLink>
    </li>

    <li
      v-for="(crumb, index) in breadcrumbs"
      :key="index"
      class="flex items-center"
    >
      <CaretRightIcon class="mr-2 w-1.5 text-blue-dark-900/60 md:mr-3" />
      <NuxtLink
        :to="{
          query: {
            [queryScope]: JSON.stringify({
              level: crumb.level,
              id: crumb.id,
            }),
          },
        }"
        class="my-1 flex items-center px-4 py-2 font-medium"
        :class="{
          'pointer-events-none rounded bg-blue-50':
            index === breadcrumbs.length - 1,
        }"
      >
        <FolderIcon class="mr-3 w-5 text-blue-800" />
        <span class="truncate text-sm font-medium sm:text-base">
          {{ crumb.title }}
        </span>
      </NuxtLink>
    </li>
  </ul>
</template>

<script setup>
defineProps({
  breadcrumbs: { type: Array, required: true },
})
const { $gsap } = useNuxtApp()
const scrollContainer = ref(null)

const queryScope = inject('queryScope', 'downloads-area')

function isOverflowing() {
  return scrollContainer.value.scrollWidth >= scrollContainer.value.clientWidth
}

function setScrollPosition() {
  if (isOverflowing()) {
    setTimeout(() => {
      const el =
        scrollContainer.value.children[
          scrollContainer.value.children.length - 1
        ]

      // scroll to last element in the breadcrumb using gsap scrollto plugin
      $gsap.to(scrollContainer.value, {
        duration: 0.5,
        scrollTo: {
          x: el.offsetLeft,
          autoKill: false,
        },
      })
    }, 100)
  }
}

defineExpose({ setScrollPosition })
</script>
